<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
<div class="loading-indicator" id="fullpage-loader">
  <ion-spinner name="crescent" color="primary"></ion-spinner>
</div>
